import { render, staticRenderFns } from "./ListaDeduccion.vue?vue&type=template&id=7245c8f5"
import script from "./ListaDeduccion.vue?vue&type=script&lang=js"
export * from "./ListaDeduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports